/*
  Componente Alpine da secao `sections/kp-reels-produto.liquid`
  ("Acompanhe as redes sociais": carrossel de reels com produto).

  Fica num asset carregado pelo snippets/cruz.liquid, e nao inline na secao, porque
  o editor de tema re-renderiza a secao injetando HTML -- e script inline injetado
  por innerHTML nao executa. Mesmo motivo pelo qual o `uzProductCard` mora no
  snippets/scripts.liquid.

  Precisa estar definido ANTES do Alpine (index-*.js, que e module e so roda no fim
  do parsing), por isso e carregado como script classico sem defer.

  Comportamento: o slide central e o "ativo" -- so ele toca, e sempre sem som ate a
  pessoa clicar no alto-falante. Os outros ficam pausados no poster. Os videos vem
  com preload="none" e sem `autoplay`/`data-uz-autoplay`, entao o uz-splide-fix.js
  nao mexe neles: quem comanda play/pause e so este arquivo.

  O carrossel e infinito (`type: 'loop'`). Antes era uma lista com comeco e fim
  (`trimSpace`, que faz a lista encostar nas bordas) e o destaque era medido pelo
  slide mais proximo do centro da area visivel. As duas coisas juntas tinham um
  furo: nas pontas nenhum slide da borda chega ao centro, entao com 8 videos numa
  tela que mostra 5 os dois primeiros e os dois ultimos nunca viravam o ativo --
  nao tocavam, nao perdiam o veu e a bolinha deles nao acendia. Arrastar com o
  mouse piorava, porque a medicao por centro e o indice do Splide discordavam e o
  destaque pulava pro ultimo ao soltar.

  No loop nao existe ponta: todo slide chega ao centro, entao o destaque pode ser
  simplesmente o indice do Splide e as duas fontes nunca mais divergem. Sairam
  junto a medicao por centro, o rAF que a acompanhava e as setas desabilitadas.
*/
window.kpReels =
  window.kpReels ||
  function (config) {
    return {
      splide: null,
      loop: false,
      active: 0,
      muted: true,
      onScreen: false,
      videos: [],
      // O template liga as setas nestes dois; no loop ficam sempre false.
      atStart: false,
      atEnd: false,
      qty: {},
      loading: {},

      init() {
        for (var i = 0; i < config.total; i++) {
          this.qty[i] = 1
          this.loading[i] = false
        }

        // Com 1 ou 2 videos o Splide nao tem slide suficiente para clonar e montar
        // o loop, entao nesse caso ele volta a ser uma lista normal.
        this.loop = config.total > 2

        // `fixedWidth` em vez de `perPage`: com perPage a largura do slide vinha da
        // largura do track, entao em tela grande o video de 9:16 crescia junto e
        // estourava a altura. Com largura fixa cabem quantos couberem, sempre com
        // um no centro, e a altura nao depende do monitor.
        var splide = new Splide(this.$refs.carousel, {
          type: this.loop ? 'loop' : 'slide',
          fixedWidth: config.videoWidth + 'px',
          focus: 'center',
          updateOnMove: true,
          start: 0,
          gap: '0.75rem',
          arrows: false,
          pagination: false,
          breakpoints: {
            640: { fixedWidth: '62vw', gap: '0.5rem' },
          },
        })

        // `move` traz o indice de destino: o destaque troca junto com a animacao em
        // vez de so no fim. `moved`/`dragged`/`scrolled` confirmam onde parou --
        // depois de um arrasto o destino so e conhecido quando o dedo solta.
        splide.on('mounted', () => this.indexSlides())
        splide.on('move', (index) => this.setActive(index))
        splide.on('moved dragged scrolled', () => this.setActive(splide.index))
        splide.on('refresh', () => {
          this.indexSlides()
          this.setActive(splide.index)
        })

        splide.mount()
        this.splide = splide
        this.indexSlides()
        this.setActive(splide.index)

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(
            (entries) => {
              this.onScreen = entries[entries.length - 1].isIntersecting
              // Som ligado nunca sobrevive a secao sair da tela.
              if (!this.onScreen) this.muted = true
              this.syncVideos()
            },
            { threshold: 0.3 }
          ).observe(this.$root)
        } else {
          this.onScreen = true
          this.syncVideos()
        }

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.muted = true
            this.syncVideos()
          }
        })
      },

      // ---- slides ----

      // O loop preenche as laterais com clones dos slides, e o Alpine inicializa
      // os clones como se fossem originais -- inclusive o x-ref do <video>, que
      // passaria a apontar pro clone. Por isso guardamos aqui os videos dos slides
      // de verdade, na ordem dos blocos, em vez de usar $refs.
      indexSlides() {
        var carousel = this.$refs.carousel
        if (!carousel) return
        var real = carousel.querySelectorAll('.splide__slide:not(.splide__slide--clone)')
        var list = []
        for (var i = 0; i < real.length; i++) list.push(real[i].querySelector('video'))
        this.videos = list
      },

      video(i) {
        return this.videos[i] || null
      },

      setActive(i) {
        if (typeof i !== 'number' || i < 0 || i > config.total - 1) return
        if (i === this.active) return
        this.active = i
        this.updateEdges()
        this.syncVideos()
      },

      // No loop nao ha ponta para desabilitar. Sem loop (1 ou 2 videos) as setas
      // param nas bordas.
      updateEdges() {
        this.atStart = !this.loop && this.active <= 0
        this.atEnd = !this.loop && this.active >= config.total - 1
      },

      // ---- navegacao ----

      step(delta) {
        if (!this.splide) return
        if (this.loop) {
          this.splide.go(delta > 0 ? '>' : '<')
          return
        }
        var next = this.active + delta
        if (next < 0 || next > config.total - 1) return
        this.goTo(next)
      },

      goTo(i) {
        if (i === this.active) return
        if (this.splide) {
          this.splide.go(i)
        } else {
          this.setActive(i)
        }
      },

      onSlideClick(i) {
        if (i !== this.active) {
          this.goTo(i)
          return
        }
        var video = this.video(i)
        if (!video) return
        if (video.paused) this.play(video)
        else video.pause()
      },

      // ---- video ----

      play(video) {
        if (!video) return
        var playing = video.play()
        if (playing && playing.catch) playing.catch(function () {})
      },

      toggleSound() {
        this.muted = !this.muted
        var video = this.video(this.active)
        if (!video) return
        video.muted = this.muted
        if (!this.muted && video.paused) this.play(video)
      },

      // Pausa elemento por elemento, nao por indice: os clones tambem tem <video>
      // dentro, e um clone tocando escondido daria som sem imagem.
      syncVideos() {
        var carousel = this.$refs.carousel
        if (!carousel) return
        var current = this.video(this.active)
        var all = carousel.querySelectorAll('video')
        for (var i = 0; i < all.length; i++) {
          if (all[i] === current) continue
          if (!all[i].paused) all[i].pause()
          all[i].muted = true
        }
        if (!current) return
        if (this.onScreen && config.autoplay) {
          current.muted = this.muted
          this.play(current)
        } else {
          if (!current.paused) current.pause()
          current.muted = true
        }
      },

      addToCart(i, variantId) {
        if (this.loading[i]) return
        this.loading[i] = true

        var items = [{ id: variantId, quantity: this.qty[i] || 1 }]

        this.$store.cart
          .addItems(items, { showCart: true })
          .then(() => {
            this.loading[i] = false
            if (!config.sideCart) {
              this.$dispatch('show-notification', {
                type: 'success',
                title: config.notifyTitle,
                description: config.notifyText,
              })
            }
            this.$dispatch('cart-change')
            this.$store.cart.fetchItems()
          })
          .catch(() => {
            this.loading[i] = false
          })
      },
    }
  }
